import ApiService from "./api.service";
export default class FicheClientService extends ApiService {
    static base_url = `${super.base_url}/fiche_clients`;
}
